module.exports = __webpack_public_path__ + "img/queryactivitytable.c0f9150e.png";